import { errorMock, IProduct, useCampaignsInfo, usePage } from '@vfit/consumer/data-access';
import { useEffect, useState } from 'react';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';
import { getAllProductsByAlternatives, getEligibilityProduct } from '../../coverageToolModal.utils';
import { IUseCoverageToolMapCardFlow } from './coverageToolMapCard.models';
import { ICheckEligibility } from '../../coverageToolModal.models';

/**
 * Flow: campaigns for logged customer
 */
export const useCoverageToolMapCard = (
  startLockInForLogged?: boolean
): IUseCoverageToolMapCardFlow => {
  const { products: allPageProducts } = usePage();
  const { product } = useCoverageToolModalProvider();
  const [checkEligibility, setCheckEligibility] = useState<
    ICheckEligibility & { lockInProduct?: IProduct }
  >({
    eligible: false,
  });
  const {
    data: campaignsData,
    error: campaignsError,
    isLoading: isLoadingCampaigns,
    isSuccess: isSuccessCampaigns,
    isError: isErrorCampaigns,
    refetch: refetchCampaigns,
  } = useCampaignsInfo({
    keyDependency: ['campaignsLockInFromHub'],
  });

  useEffect(() => {
    if (isSuccessCampaigns) {
      const products = getAllProductsByAlternatives(product, allPageProducts);
      const { campaignEligibility, lockInProduct } = getEligibilityProduct(
        products || [],
        campaignsData
      );
      setCheckEligibility({
        ...campaignEligibility,
        lockInProduct,
      });
    }
  }, [isSuccessCampaigns]);

  useEffect(() => {
    if (startLockInForLogged) refetchCampaigns();
  }, [startLockInForLogged]);

  return {
    campaigns: {
      isLoading: isLoadingCampaigns,
      isError: isErrorCampaigns,
      isSuccess: isSuccessCampaigns,
      data: campaignsData,
      ...(campaignsError && { error: errorMock('campaigns', campaignsError) }),
    },
    checkEligibility,
  };
};

